import React from 'react';
import PropTypes from "prop-types";

export default function ImageMessage({item, message}) {
  return (
    <div className="messageImage">
      {!item.confirmed && <div>{__("Send...")}</div>}
      <img src={message.url}/>
    </div>
  );
}

ImageMessage.propTypes = {
  item: PropTypes.shape({
    confirmed: PropTypes.bool.isRequired
  }),
  message: PropTypes.shape({
    url: PropTypes.string.isRequired
  })
};
